// Imports
import firebase from '../config/FirebaseConfig'
import AxiosConfig from '../foreplayServer/serverAxiosConfig'


// Setup
const db = firebase.firestore()

// Get All By User
const getAllByUser = async () => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const snapshot = await db.collection('tags').where('created_by', '==', user.uid).get()

  return snapshot.docs?.map(doc => {
    return {
      color: 'gray', // If the color is not defined, default to gray
      ...doc.data() || [],
      id: doc.id
    }
  })
}

const getAllByTeam = async (teamId) => {
  const snapshot = await db.collection('tags').where('teamId', '==', teamId).get()

  return snapshot.docs?.map(doc => {
    return {
      color: 'gray', // If the color is not defined, default to gray
      ...doc.data() || [],
      id: doc.id
    }
  })
}

const getTagsArray = async (tagsToGet) => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const tags = await Promise.all(
    tagsToGet.map(async tagId => {
      try {
        const tagDoc = await db.collection('tags').doc(tagId).get()
        return {
          color: 'gray', // If the color is not defined, default to gray
          ...tagDoc.data(),
          id: tagDoc.id
        }
      } catch (error) {
        console.error('Error fetching tag:', tagId, error)
        return { id: tagId }
      }
    })
  )

  return tags.filter(tag => tag.name);
}

const getTagByName = async (tagName, teamId) => {
  const user = firebase.auth().currentUser

  if (!user) return []

  let snapshot
  if (teamId) {
    snapshot = await db.collection('tags').where('teamId', '==', teamId).where('name', '==', tagName).get()
  } else {
    snapshot = await db.collection('tags').where('created_by', '==', user.uid).where('name', '==', tagName).get()
  }

  return snapshot.docs?.map(doc => {
    return {
      color: 'gray', // If the color is not defined, default to gray
      ...doc.data() || [],
      id: doc.id
    }
  })
}

const update = async (tagId, payload) => {
  const user = firebase.auth().currentUser
  if (!user) return []

  await db.collection('tags').doc(tagId).update(payload)
}

const create = async (tagName, teamId, tagColor = 'gray') => {
  const user = firebase.auth().currentUser

  const payload = { name: tagName, color: tagColor, created_by: user.uid, created_at: new Date().getTime() }

  if (teamId) {
    payload.teamId = teamId
  }

  const { id } = await db.collection('tags').add(payload)

  return { ...payload, id }
}

// named deleteTag to avoid conflict with JS delete keyword
const deleteTag = async (tagId) => {
  const user = firebase.auth().currentUser
  const userAuthToken = await user.getIdToken()

  if (!user) return null

  const { data: response } = await AxiosConfig.delete(`/fs/tags/${tagId}`, {
    headers: { Authorization: `Bearer ${userAuthToken}` }
  })

  return response.data
  // if (!user) return []

  // const tagAds = await getAdsByTagId(tagId)

  // console.log('Ads with tag:', tagAds)

  // // Remove the tag from all ads that have it
  // await Promise.all(tagAds.map(ad => {
  //   const newTags = ad.tags.filter(tag => tag !== tagId)
  //   return db.collection('ads').doc(ad.id).update({ tags: newTags })
  // }));

  // await db.collection('tags').doc(tagId).delete()
}

export default {
  update,
  create,
  deleteTag,
  getAllByUser,
  getTagByName,
  getAllByTeam,
  getTagsArray,
}
